import {createAsyncThunk} from "@reduxjs/toolkit";
import {toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Include helper methods for API calls
import {
    addNewUnit as addNewUnitApi,
    deleteUnit as deleteUnitApi,
    getUnitById as getUnitByIdApi,
    getUnits as getUnitsApi,
    getUnitsByBlock as getUnitsByBlockApi,
    updateUnit as updateUnitApi,
} from "../../helpers/fakebackend_helper";

// Fetch Units
export const getUnits = createAsyncThunk("units", async (queryParams) => {
  try {
      return await getUnitsApi(queryParams);
  } catch (error) {
    toast.error("Failed to fetch units", { autoClose: 3000 });
    throw error;
  }
});

// Fetch Unit by ID
export const getUnitById = createAsyncThunk(
  "units/getUnitById",
  async (id) => {
    try {
        return await getUnitByIdApi(id);
    } catch (error) {
      toast.error("Failed to fetch unit by ID", { autoClose: 3000 });
      throw error;
    }
  }
);

export const getUnitsByBlock = createAsyncThunk(
  "units/getUnitsByBlock",
  async (blockId) => {
    try {
        return await getUnitsByBlockApi(blockId);
    } catch (error) {
      toast.error("Failed to fetch units by block", { autoClose: 3000 });
      throw error;
    }
  }
);

// Add New Unit
export const addNewUnit = createAsyncThunk(
  "units/addNewUnit",
  async (unit) => {
    try {
      const response = await addNewUnitApi(unit);
      toast.success("Unit Added Successfully", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Failed to add unit", { autoClose: 3000 });
      throw error;
    }
  }
);

// Update Unit
export const updateUnit = createAsyncThunk(
  "units/updateUnit",
  async (unit) => {
    try {
      const response = await updateUnitApi(unit);
      toast.success("Unit Updated Successfully", { autoClose: 3000 });
      return response;
    } catch (error) {
      toast.error("Failed to update unit", { autoClose: 3000 });
      throw error;
    }
  }
);

// Delete Unit
export const deleteUnit = createAsyncThunk(
  "units/deleteUnit",
  async (unitId) => {
    try {
      const response = await deleteUnitApi(unitId);
      toast.success("Unit Deleted Successfully", { autoClose: 3000 });
      return { unitId, ...response };
    } catch (error) {
      toast.error("Failed to delete unit", { autoClose: 3000 });
      throw error;
    }
  }
);
